"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CaseCancellation = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ui_common_1 = require("@codametrix/ui-common");
var ui_components_1 = require("@codametrix/ui-components");
var react_1 = __importDefault(require("react"));
var formDef = {
    buttons: [
        {
            className: 'add-button',
            buttonType: 'submit',
            buttonText: 'Proceed'
        },
        {
            buttonText: 'dismiss',
            buttonType: 'link',
            action: 'cancel',
            link: '/go/elsewhere'
        }
    ]
};
var CaseCancellation = /** @class */ (function (_super) {
    __extends(CaseCancellation, _super);
    function CaseCancellation(props) {
        var _this = _super.call(this, props) || this;
        _this.handleCancelDismiss = _this.handleCancelDismiss.bind(_this);
        _this.handleCaseCancel = _this.handleCaseCancel.bind(_this);
        return _this;
    }
    CaseCancellation.prototype.handleCancelDismiss = function (event) {
        event.preventDefault();
        this.props.onCaseCancelDismiss(event);
    };
    CaseCancellation.prototype.handleCaseCancel = function (event) {
        event.preventDefault();
        var cursorAPIPayload = {
            operation: ui_common_1.commonEnums.CursorOperation.NEXT,
            cursorAPIContext: this.props.cursorAPIContext,
            hasAmplifyCaseRunV2Access: ui_common_1.Utils.doesPathEndWithV2()
        };
        this.props.onCaseCancel({
            processInstance: this.props.processInstance,
            uiMode: this.props.UIMode,
            cursorAPIPayload: cursorAPIPayload
        });
    };
    CaseCancellation.prototype.render = function () {
        var displayCancellation = this.props.displayCancellation;
        if (!displayCancellation)
            return (0, jsx_runtime_1.jsx)("span", { className: "case-cancellation-empty" });
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "case-cancellation-form" }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.Modal, __assign({ title: "Void this case?", onClose: this.handleCancelDismiss }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "cols" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "col-12" }, { children: (0, jsx_runtime_1.jsx)("p", __assign({ className: "void-subtitle" }, { children: "Voided cases are not submitted for reimbursement, and will no longer be editable." })) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "col-12 cancel-buttons-col" }, { children: [(0, jsx_runtime_1.jsx)("button", __assign({ onClick: this.handleCaseCancel, className: "chakra-primary-button qa-rounded-button" }, { children: "Yes, Void" })), (0, jsx_runtime_1.jsx)("button", __assign({ onClick: this.handleCancelDismiss, className: "chakra-secondary-button cancel-link qa-cancel-link" }, { children: "No, Cancel" }))] }))] })) })) })));
    };
    return CaseCancellation;
}(react_1["default"].Component));
exports.CaseCancellation = CaseCancellation;
//# sourceMappingURL=case-cancellation.js.map